import React, { Component } from "react";
import PropTypes from "prop-types";
import BCDKModal from "../../../../routes/BaoVeMoiTruong/BaoCaoDinhKy/Modal/BCDKModal"
import BCDKModal_DTM from "../../../../routes/DTM/BaoCaoDinhKy/Modal/BCDKModal"
class DNBCModal extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentDidMount() {

  }


  render() {
    const { handleAdd, handleCloseModal, selectedRow, isEdit, user, mode, phanloai } = this.props
    return (
      <div>
        {phanloai === "BVMT" &&
          <BCDKModal
            handleAdd={handleAdd}
            handleCloseModal={handleCloseModal}
            selectedRow={selectedRow}
            isEdit={isEdit}
            user={user}
            mode={mode}
            dulieu={true}
          />}

        {phanloai === "DTM" &&
          <BCDKModal_DTM
            handleAdd={handleAdd}
            handleCloseModal={handleCloseModal}
            selectedRow={selectedRow}
            isEdit={isEdit}
            user={user}
            mode={mode}
            dulieu={true}
          />}
      </div>
    );
  }
}

DNBCModal.propTypes = {
  handleAddAccount: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  isEdit: PropTypes.bool
};

export default DNBCModal;
